import { defineRecipe } from '@chakra-ui/react';

const MainBody = {
  fontSize: '16px',
  letterSpacing: 0,
  lineHeight: '22px',
};

const SmallBody = {
  fontSize: '14px',
  letterSpacing: 0,
  lineHeight: '20px',
};

const ExtraSmallBody = {
  fontSize: '12px',
  letterSpacing: 0,
  lineHeight: '18px',
};

export const typographyMixins = {
  'Header.H1': {
    fontSize: '40px',
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: '48px',
  },
  'Header.H2': {
    fontSize: '32px',
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: '40px',
  },
  'Header.H3': {
    fontSize: '24px',
    fontWeight: '600',
    letterSpacing: 0,
    lineHeight: '34px',
  },
  Subheader: {
    fontSize: '20px',
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: '28px',
  },
  MainBodyRegular: {
    ...MainBody,
    fontWeight: '400',
  },
  MainBodyMedium: {
    ...MainBody,
    fontWeight: '500',
  },
  MainBodyDemiBold: {
    ...MainBody,
    fontWeight: '600',
  },
  SmallBodyRegular: {
    ...SmallBody,
    fontWeight: '400',
  },
  SmallBodyMedium: {
    ...SmallBody,
    fontWeight: '500',
  },
  SmallBodyDemiBold: {
    ...SmallBody,
    fontWeight: '600',
  },
  ExtraSmallBodyRegular: {
    ...ExtraSmallBody,
    fontWeight: '400',
  },
  ExtraSmallBodyMedium: {
    ...ExtraSmallBody,
    fontWeight: '500',
  },
  ExtraSmallBodyDemiBold: {
    ...ExtraSmallBody,
    fontWeight: '600',
  },
  Link: {
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'none',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
  },
};

export const typographyRecipe = defineRecipe({
  variants: {
    variant: typographyMixins,
  },
});
